'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const DeliveryDhlAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 84 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsxs("g", { clipPath: "url(#clip0_5448_6761)", children: [
        /* @__PURE__ */ jsx("rect", { width: 84, height: 58, rx: 4, fill: "#FFCC00" }),
        /* @__PURE__ */ jsx("path", { d: "M0 32.3589H11.3597L10.7391 33.1931H0V32.3589Z", fill: "#D40511" }),
        /* @__PURE__ */ jsx("path", { d: "M0 30.8105H12.5139L11.892 31.6439H0V30.8105Z", fill: "#D40511" }),
        /* @__PURE__ */ jsx("path", { d: "M0 33.9082H10.2064L9.58843 34.7365H0V33.9082Z", fill: "#D40511" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M83.9998 33.1932H72.6846L73.3048 32.3594H83.9998V33.1932Z",
            fill: "#D40511"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M84.0001 34.7365L71.5342 34.7378L72.1518 33.9082H84.0001V34.7365Z",
            fill: "#D40511"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M74.4576 30.8105H83.9998V31.6444L73.837 31.6452L74.4576 30.8105Z",
            fill: "#D40511"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M11.0021 34.7366L16.3926 27.5H23.0818C23.8212 27.5 23.8115 27.7774 23.4504 28.2612C23.0835 28.7524 22.459 29.5971 22.0852 30.0958C21.8955 30.3491 21.5525 30.8106 22.689 30.8106H31.6505C30.9052 31.8194 28.4876 34.7366 24.147 34.7366H11.0021Z",
            fill: "#D40511"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M41.874 30.8101L38.9512 34.7366H31.2401C31.2401 34.7366 34.1617 30.8107 34.1643 30.8107L41.874 30.8101Z",
            fill: "#D40511"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M53.025 30.8108L50.1005 34.7367H42.3923C42.3923 34.7367 45.3142 30.8108 45.3169 30.8108H53.025Z",
            fill: "#D40511"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M55.532 30.8107C55.532 30.8107 54.9688 31.5719 54.695 31.9371C53.7267 33.2302 54.5825 34.7365 57.7426 34.7365H70.122L73.046 30.8105L55.532 30.8107Z",
            fill: "#D40511"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M14.7725 23L12.0887 26.6029H26.7154C27.4547 26.6029 27.445 26.8802 27.0836 27.364C26.7167 27.8547 26.1025 28.7091 25.7288 29.2078C25.539 29.4606 25.196 29.922 26.3326 29.922H32.3139C32.3139 29.922 33.2782 28.6256 34.0861 27.5419C35.1856 26.0676 34.1815 23 30.251 23H14.7725Z",
            fill: "#D40511"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M53.6864 29.922H34.8262L39.9837 23H47.6919L44.7365 26.9688H48.1771L51.1347 23H58.8421L53.6864 29.922Z",
            fill: "#D40511"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M69.5179 23L64.3616 29.922H56.1934C56.1934 29.922 61.3514 23 61.354 23H69.5179Z",
            fill: "#D40511"
          }
        )
      ] }),
      /* @__PURE__ */ jsx("rect", { x: 0.5, y: 0.5, width: 83, height: 57, rx: 3.5, stroke: "#F1F1F1" }),
      /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "clip0_5448_6761", children: /* @__PURE__ */ jsx("rect", { width: 84, height: 58, rx: 4, fill: "white" }) }) })
    ]
  }
);
const VpDeliveryDhlAsset = forwardRef(DeliveryDhlAsset);

export { VpDeliveryDhlAsset as default };
